export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="16" fill="#101826" stroke="rgba(16,185,129,0.35)" strokeWidth="2" />
      <path d="M19 47V17h8.5L39 34V17h7v30h-8.5L26 30v17h-7z" fill="#10B981" />
      <path d="M45 12l2.4 5 5 2.4-5 2.4L45 27l-2.4-5.2-5-2.4 5-2.4L45 12z" fill="#F59E0B" />
    </svg>
  );
}

export default function Logo() {
  return (
    <a href="#top" className="flex items-center gap-3 group" data-testid="brand-logo">
      <LogoMark className="h-10 w-10 transition-transform duration-300 group-hover:rotate-6" />
      <span className="font-display font-extrabold uppercase tracking-wide text-white text-lg lg:text-xl leading-none">
        Fitness Fanatic Nik <span className="text-emerald-400">|</span> <span className="text-slate-300">Nikhil Shrirao</span>
      </span>
    </a>
  );
}